import React from 'react';
import { path, is } from 'ramda';
import styled from 'styled-components';
import { FixedSizeList } from 'react-window';

type Props = {
    children?: React.ReactNode | null;
    width?: number;
    height?: number;
    itemHeight?: number;
    className?: string;
};

const List = styled.ul`
    padding: 0;
    list-style: none;
    margin: 0;
    width: 100%;
`;

const DropdownItemWrapper = styled.li`
    display: block;
    width: 100%;
    &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
`;

const getChildrenArray = (children?: React.ReactNode | null): React.ReactNode[] => {
    if (children && path(['type'], children) === React.Fragment) {
        return path(['props', 'children'], children) as React.ReactNode[];
    }
    if (children && is(Array, children)) {
        return children as React.ReactNode[];
    }
    return children ? [children] : [];
};

const DropdownList = React.forwardRef<HTMLUListElement, Props>(
    ({ children = [], itemHeight = 48, height, ...rest }, ref) => {
        // enforce array format
        const childrenArray = getChildrenArray(children);

        const Row = ({ index, style }: { index: number; style: any }) => (
            <DropdownItemWrapper key={index} style={style}>
                {childrenArray[index]}
            </DropdownItemWrapper>
        );

        if (!height) {
            return (
                <List {...rest} ref={ref}>
                    {children}
                </List>
            );
        }

        return (
            <FixedSizeList
                innerElementType={innerProps => <List {...innerProps} ref={ref} />}
                height={Math.min(height, childrenArray.length * itemHeight)}
                width="100%"
                itemCount={childrenArray.length}
                itemSize={itemHeight}
            >
                {Row}
            </FixedSizeList>
        );
    },
);

export default DropdownList;
